import script from "./DecisionNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecisionNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./DecisionNavigation.vue?vue&type=style&index=0&id=630b97a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-630b97a2"]])

export default __exports__